import { useState } from "react";

import BarLoader from "react-spinners/BarLoader";

import { useNavigate, useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { Button } from "reactstrap";

import { FaRegCircleXmark } from "react-icons/fa6";

function PaymentUnsuccessfulPage() {
  const { t } = useTranslation("common");

  const params = useParams();
  const orderUid = params.orderUid;

  console.log(orderUid);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="paymentSuccessfulPage" className="page">
      <div id="paymentSuccessfulInnerContainer">
        <FaRegCircleXmark />
        <h1>{t("paymentUnsuccessful").toUpperCase()}!</h1>
        <p style={{ color: "#FFFFFF" }}>{t("sorrySomethingWentWrong")}</p>
        <Button onClick={() => navigate("/shop")} className="primaryBtn">
          {t("backToShop").toUpperCase()}
        </Button>
      </div>
    </div>
  );
}

export default PaymentUnsuccessfulPage;
